import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"


declare var window: any

export type definirPrioridadeMontagemItemInput = {

    identificadorItem: number,
    prioridadeMontagem: boolean,
    itemOrcamentoLegado?: any
}

export async function definirPrioridadeMontagemItem(params: definirPrioridadeMontagemItemInput) {  // 4456839

    const orcamentoAtualizado = await microuniversoApi.Orcamento.definirPrioridadeMontagemItem(
        store.getState().orcamento.IdentificadorOrcamento,
        params.identificadorItem,
        params.prioridadeMontagem
    )

    const atualizarOrcamentoLegado = () => {
        const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == params.identificadorItem)
        const orcamentoLegado = window.orcamentoController.model
        orcamentoLegado.atualizar(orcamentoAtualizado)
    
    }
    atualizarOrcamentoLegado()
}